import React, { useState }  from 'react'
import plus from '../assets/+.svg'
import NativeSelect from '@mui/material/NativeSelect';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    
    '& .MuiInputBase-input': {
      borderRadius: 5,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #BCD4E4',
      fontSize: 16,
      height: '35px',
      width: '463px',
      color: '#98BCD6',
      paddingLeft: '12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        'Inter',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 5,
      },
    },
  }));
function AddForecastForm({ setRefresh, setOpenPopup, setLoading, taskID, category, mainBudget}) {
    const [name, setName] = useState('');
    const [value, setValue] = useState("0.00");
    const [budget, setBudget] = useState("");
    function isFloat(value) {
      // Regular expression to match a floating-point number
      const floatRegex = /^[+-]?\d+(\.\d+)?$/;
    
      return floatRegex.test(value);
    }
    const handleSubmit = (e) => {
      console.log(budget, name, value)
        e.preventDefault();
        if(!isFloat(parseFloat(value.replace(/,/g, ''))))
        return;
        if(name.length ===0 || budget == null || budget == '') return;
        setOpenPopup(false)
        setLoading(true)
        fetch('/api-dev/expenses/CreateBudgetLine/',{
   method: "POST",
       body:JSON.stringify({TaskID:taskID, BudgetType:category, BudgetLineName:name, Value:parseFloat(value.replace(/,/g, '')), MainBudgetLineID:budget}),
       headers: {
          'Content-Type': 'application/json',
        },
     })
       
       .then(res =>{
        setName("")
        setValue('')
        setRefresh(prev => !prev)
        
        console.log("added in database")
       })
       
        console.log(name, value, budget);
    }
    const formatValue = (number) => {
        const formattedNumber = number.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return `${formattedNumber}€`;
      };
      const handleChangeValue = (e) => {
        const rawValue = e.target.value.replace(/,/g, '');
        const formattedValue = rawValue
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        setValue(formattedValue);
      };
      const handleChangeName = (e) => {
        setName(e.target.value);
      }
    return (
        <>
        <form onSubmit={handleSubmit}>
        <div className='form-input'>
        <label className='form-input-label'>Contract concerned*</label>
            <NativeSelect
          id="demo-customized-select-native"
          input={<BootstrapInput />}
          value={budget}
          onChange={(e)=>setBudget(e.target.value)}
        >
            <option aria-label="None" value={""}/>
            {mainBudget.map((budget,index) => (
                <option key={index} value={budget.MainBudgetLineID}>{budget.MainBudgetLineName}</option>
            ))}
        </NativeSelect>
        </div>
        
            <div className='form-input' style={{marginTop:'30px'}}>
                <label className='form-input-label'>Forecast title*</label>
                <input value={name} onChange={handleChangeName} className='form-input-field input' type="text" placeholder="Name" />
            </div>
            <div className='form-input' style={{marginTop:'30px'}}>
                <label className='form-input-label'>Forecast amount*</label>
                <input value={value} onChange={handleChangeValue} id="myNumberInput" className='form-input-field' type="text" placeholder="0,00" />
            </div>
            <div className='form-button' style={{marginTop:'40px'}}>
            <button style={{cursor:'pointer'}} type="submit" className='form-submit'>
                <img src={plus} alt="plus" className='form-submit-icon' />
                &nbsp;
                <span className='form-submit-text'>Create forecast</span>
            </button>
            </div>
        </form>
            
        </>

    )
}

export default AddForecastForm